import {RegionType} from "../../../region/types/RegionType";
import {DEFAULT_DISTANCE, DEFAULT_DISTANCE_FOR_TOWN} from "../constants/offer_list";

export const getOfferListsDefaultDistance = (regionType: RegionType): number => {
    switch (regionType) {
        case RegionType.CITY:
        case RegionType.TOWN:
            return DEFAULT_DISTANCE_FOR_TOWN;
        default:
            return DEFAULT_DISTANCE;
    }
};
